"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewWithStyle = void 0;
var react_native_1 = require("react-native");
var React = require("react");
/**
 * factory for making a View Component which applies default styles
 * the style prop comes second, so custom style declarations will override the provided defaults
 */
exports.ViewWithStyle = function (propsMapper) {
    return function (props) {
        return (React.createElement(react_native_1.View, __assign({}, props, { style: [
                typeof propsMapper === "function" ? propsMapper(props) : propsMapper,
                props.style,
            ] })));
    };
};
//# sourceMappingURL=ViewWithStyle.js.map